export const capitalizeFirstLetter = (string: string): string =>
  `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
